export default function median(values: number[]): number {
    const sorted = [...values].sort((a, b) => a - b);

    const half = Math.floor(values.length / 2);

    return (
        values.length % 2
            ? sorted[half]
            : (sorted[half - 1] + sorted[half]) / 2
    );
}